import { render, staticRenderFns } from "./cashbook.vue?vue&type=template&id=366d50ab&scoped=true&"
import script from "./cashbook.vue?vue&type=script&lang=js&"
export * from "./cashbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366d50ab",
  null
  
)

export default component.exports